import { useEffect } from "react";
import { toast } from "sonner";

declare const __BUILD_ID__: string;
export const BUILD_ID: string = typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "dev";

async function reloadFresh() {
  try {
    if ("caches" in window) await Promise.all((await caches.keys()).map((k) => caches.delete(k)));
  } catch { /* noop */ }
  const url = new URL(window.location.href);
  url.searchParams.set("_v", Date.now().toString(36));
  window.location.replace(url.toString());
}

/** Polls /version.json and offers a reload when a newer build is deployed. */
export function useVersionCheck() {
  useEffect(() => {
    const u = new URL(window.location.href);
    if (u.searchParams.has("_v")) {
      u.searchParams.delete("_v");
      window.history.replaceState(window.history.state, "", u.toString());
    }
    let shown = false;
    const check = async () => {
      if (shown || document.visibilityState === "hidden") return;
      try {
        const r = await fetch(`/version.json?ts=${Date.now()}`, { cache: "no-store" });
        if (!r.ok) return;
        const { id } = await r.json();
        if (id && id !== BUILD_ID) {
          shown = true;
          toast("A new version is available", {
            duration: Infinity,
            action: { label: "Reload", onClick: () => void reloadFresh() },
          });
        }
      } catch { /* offline */ }
    };
    check();
    const t = window.setInterval(check, 60_000);
    const onVis = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { window.clearInterval(t); document.removeEventListener("visibilitychange", onVis); };
  }, []);
}
